<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5S9rL0/tc-custom/9780253059420.jpg?1721450690842" alt="This image is the cover for the book Yeshiva and the Rise of Modern Hebrew Literature, Jews in Eastern Europe"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Yeshiva and the Rise of Modern Hebrew Literature, Jews in Eastern Europe
      </h1>
      <p class="bookDescription body article font2">
        <p><i>The Yeshiva and the Rise of Modern Hebrew Literature</i> argues that the institution of the yeshiva and its ideals of Jewish textual study played a seminal role in the resurgence of Hebrew literature in modern times. Departing from the conventional interpretation of the origins of Hebrew literature in secular culture, Marina Zilbergerts points to the practices and metaphysics of Talmud study as its essential animating forces. Focusing on the early works and personal histories of founding figures of Hebrew literature, from Moshe Leib Lilienblum to Chaim Nachman Bialik, <i>The Yeshiva and the Rise of Modern Hebrew Literature</i> reveals the lasting engagement of modern Jewish letters with the hallowed tradition of rabbinic learning. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marina Zilbergerts
      </h2>
      
      <p class="authorDescription body article"><P>Marina Zilbergerts is an Assistant Professor of Jewish Literature and Thought at the Mosse/Weinstein Center for Jewish Studies and the Department of German, Nordic, and Slavic at the University of Wisconsin–Madison. This is her first book. </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4cb30635